import { Button, styled, useTheme } from '@mui/material';
import { FC, useCallback } from 'react';
import { SelectItem } from '../../types';

type Props = {
  options: SelectItem[];
  selectedItems: SelectItem[];
  onSelect: (items: SelectItem[]) => void;
  chipHeight?: string;
};

const Wrapper = styled('div')`
  display: flex;
  gap: 8px;
`;

const ButtonChip = styled('div')<{ isSelected?: boolean }>`
  .MuiButton-outlined {
    border: 1px solid
      ${({ theme, isSelected }) =>
        isSelected ? theme.colors.textStatus.active : theme.colors.border.default};
    color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.textStatus.active : theme.colors.text.main};
  }
  .MuiButton-outlined:hover {
    border: 1px solid ${({ theme }) => theme.colors.textStatus.active};
    color: ${({ theme }) => theme.colors.textStatus.active};
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.surfaceStatus.active : 'transparent'};
  }
`;

export const ChipsSelectorMultiselect: FC<Props> = ({
  options,
  selectedItems,
  onSelect,
  chipHeight,
}) => {
  const { colors } = useTheme();
  const isSelected = useCallback(
    (item: SelectItem) => selectedItems.some((i) => i.id === item.id),
    [selectedItems]
  );
  const onSelectItem = useCallback(
    (item: SelectItem) => {
      if (isSelected(item)) {
        onSelect(selectedItems.filter((i) => i.id !== item.id));
      } else {
        onSelect([...selectedItems, item]);
      }
    },
    [selectedItems, onSelect, isSelected]
  );

  return (
    <Wrapper>
      {options.map((o) => (
        <ButtonChip key={o.id} isSelected={isSelected(o)}>
          <Button
            startIcon={o.icon ? o.icon : null}
            variant='outlined'
            onClick={() => onSelectItem(o)}
            style={{
              backgroundColor: isSelected(o) ? colors.surfaceStatus.active : colors.surfaceBackground.bg4,
              height: chipHeight ? chipHeight : 'auto',
            }}
          >
            {o.value}
          </Button>
        </ButtonChip>
      ))}
    </Wrapper>
  );
};
